export default __webpack_public_path__ + "static/media/container-right.a2a4f621.jpg";